import { render, staticRenderFns } from "./DP.vue?vue&type=template&id=245d4198&"
import script from "./DP.vue?vue&type=script&lang=js&"
export * from "./DP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports